<template>
    <div v-bind:id="idMap" class="amap">
    </div>
</template>

<script>
import AMap from 'AMap';
import AMapUI from 'AMapUI';
export default {
    name: 'amap-point',
    created () {
        this.$nextTick(function () {
            var self = this;
            this.getAmapApi().then(AMap => {
                self.map = new AMap.Map(self.idMap, {
                    zoom: 12,
                    center: [114.06667, 22.61667]
                });

                AMapUI.load(['ui/overlay/SimpleInfoWindow', 'ui/misc/PointSimplifier'], function (SimpleInfoWindow, PointSimplifier) {
                    if (!PointSimplifier.supportCanvas) {
                        alert('当前环境不支持 Canvas！');
                        return;
                    }
                    self.initPage(PointSimplifier);
                    self.initInfo(SimpleInfoWindow);
                });
            });
        });
    },
    data () {
        return {
            idMap: 'amap',
            pointSimplifierIns: {},
            mapData: false,
            pointSim: false,
            myData: [],
            map: {},
            infoWindow: null,
            canRender: true,
            hoverPoit: null,
            firstRender: true
        };
    },
    props: ['poits', 'selectOne'],
    methods: {
        getAmapApi () {
            return new Promise(function (resolve, reject) {
                resolve(AMap);
            });
        },
        initPage (PointSimplifier) {
            var self = this;
            self.pointSimplifierIns = new PointSimplifier({
                map: self.map, // 关联的map
                autoSetFitView: true,
                getPosition: function (item) {
                    if (!item) {
                        return null;
                    }
                    // 返回经纬度
                    return item.gps;
                },
                getHoverTitle: function (dataItem, idx) {
                },
                // 使用GroupStyleRender
                renderConstructor: PointSimplifier.Render.Canvas.GroupStyleRender,
                renderOptions: {
                    // 点的样式
                    pointStyle: {
                        width: 5,
                        height: 5,
                        fillStyle: '#A2D0FA'
                    },
                    getGroupId: function (item, idx) {
                        return item.groupId;
                    },
                    groupStyleOptions: function (gid) {
                        return groupStyleMap[gid];
                    }
                }
            });
            function onIconLoad () {
                self.pointSimplifierIns.renderLater();
            }

            function onIconError (e) {
                alert('图片加载失败！');
            }

            var groupStyleMap = {
                'alarm': {
                    pointStyle: {
                        content: PointSimplifier.Render.Canvas.getImageContent(
                            './static/img/car_alarm.png', onIconLoad, onIconError),
                        width: 30,
                        height: 44,
                        offset: ['-50%', '-80%'],
                        fillStyle: null
                    }
                },
                'run': {
                    pointStyle: {
                        content: PointSimplifier.Render.Canvas.getImageContent(
                            './static/img/car_run.png', onIconLoad, onIconError),
                        width: 30,
                        height: 44,
                        offset: ['-50%', '-80%'],
                        fillStyle: null
                    }
                },
                'stop': {
                    pointStyle: {
                        content: PointSimplifier.Render.Canvas.getImageContent(
                            './static/img/car_stop.png', onIconLoad, onIconError),
                        width: 30,
                        height: 44,
                        offset: ['-50%', '-80%'],
                        fillStyle: null
                    }
                }
            };
            self.pointSimplifierIns.on('pointMouseover', function (e, record) {
                self.hoverPoit = record.data;
                self.$emit('hover', record.data);
                self.canRender = false;
                self.infoWindow.open(self.map, record.data.gps);
            });
            self.pointSimplifierIns.on('pointMouseout', function (e, record) {
                self.infoWindow.close();
                self.selectOne.show = 'show';
                self.canRender = true;
            });
            self.pointSimplifierIns.on('pointClick', function (e, record) {
                self.$router.push({ path: '/car-tracing' });
                localStorage.setItem('SELECTCARID', record.data.id);
            });
            self.pointSim = true;
        },
        initInfo (SimpleInfoWindow) {
            var tpl = '' +
            '<div class="maker-info <% if(run_status===0) { %> alarm <% }else if(run_status ===1){%> run <% }else{%>stop<%}%> ">' +
            '    <p class="title">车辆当前信息</p>' +
            '    <p class="info">' +
            '        时间: <%= time %>' +
            '        <br />电池编码: <%= battery_code %>' +
            '        <br />电池状态: <%= battery_status %>' +
            '        <br />SOC: <%= soc %>' +
            '        <br />车牌号码: <%= plate_number %>' +
            '        <br />厂家车辆编号: <%= production_vehicle_no %>' +
            '        <br />系统运行状态: <%= system_run_status %>' +
            '        <br />速度: <%= velocity %>' +
            '        <br />方位: <%= direction %>' +
            '        <br />地址: <%= gps %>' +
            '    </p>' +
            '    <div class="maker-loading <% if(battery_code) { %> hide <% } %>">' +
            '       <div class="el-loading-spinner">' +
            '         <svg viewBox="25 25 50 50" class="circular">' +
            '               <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>' +
            '         </svg>' +
            '       </div>' +
            '    </div>' +
            '</div>';
            this.infoWindow = new SimpleInfoWindow({
                infoTitle: '',
                infoBody: tpl,
                offset: new AMap.Pixel(0, -38)
            });
        }
    },
    computed: {
        initData: function () {
            return this.pointSim && this.mapData;
        }
    },
    watch: {
        poits: {
            handler: function (val, oldVal) {
                this.myData = val;
                this.mapData = !this.mapData;
            },
            deep: true
        },
        selectOne: {
            handler: function (val, oldVal) {
                if (this.hoverPoit.id === val.id) {
                    this.infoWindow.setInfoTplData(val);
                }
            },
            deep: true
        },
        initData: function (val, oldVal) {
            if (this.canRender) {
                this.pointSimplifierIns.setData(this.myData);
            }
            if (this.firstRender) {
                this.pointSimplifierIns._opts.autoSetFitView = false;
                this.firstRender = false;
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./map-style.css"></style>



// WEBPACK FOOTER //
// amap-point.vue?bf288d4e